import React from "react";
import "./NotFound.scss";

const NotFound = () => {
  return (
    <div className="v2-not-found">
      <div className="v2-not-found__content">
        <div className="v2-not-found__text-wrap">
          <div className="v2-not-found__titles">
            <h2 className="v2-not-found__error-code">Error 404</h2>
            <h1 className="v2-not-found__title">Journey Not Found!</h1>
          </div>
          <div className="v2-not-found__actions">
            <p className="v2-not-found__desc">
              The journey you’re trying to access doesn’t exist or has been removed
            </p>
          </div>
        </div>

        <div className="v2-not-found__illustration">
          <img
            src="https://hbx-assets.s3.us-east-1.amazonaws.com/dashboard/not-found.png"
            alt="404 Illustration"
          />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
